import { useInView } from "react-intersection-observer";
import MainBanner from "../../components/MainBanner";
import { useEffect } from "react";
import { useActiveContext } from "../../context";
import Artists from "../../components/Artists";
import EventBanner from "../../components/EventBanner";
import { Grid } from "@mui/material";
import SoundCloudBanner from "../../components/SoundCloudBanner";
import styles from "./styles";

const LandingPage = () => {
  const { setIsActive } = useActiveContext();
  const { ref, inView } = useInView({
    threshold: 0.1,
    initialInView: true,
  });
  useEffect(() => {
    setIsActive(inView);
  }, [inView, setIsActive]);

  return (
    <Grid container justifyContent={"center"} gap={{ xs: 8, md: 20 }} sx={styles.containerSx}>
      <MainBanner imageRef={ref} />
      <EventBanner />
      <Artists isLandingPage={true} />
      <SoundCloudBanner />
    </Grid>
  );
};

export default LandingPage;
